import { useQuery, UseQueryOptions } from 'react-query';

import { indexCustomerTransactions } from 'services/api-ops.service';
import { adminReadTransaction } from 'services/api-payments.service';
import {
  ITopupFilter,
  ITransaction,
  ITopupPaymentTransaction,
} from 'shared/interfaces/transaction.interface';

const QUERY_KEYS = {
  GET_TOPUP_CARD: 'GET_TOPUP_CARD',
  GET_TOPUP_CARD_DETAIL: 'GET_TOPUP_CARD_DETAIL',
} as const;

export function useIndexCustomerTransactions(
  userId: string,
  filter: ITopupFilter,
  options?: UseQueryOptions<ITransaction[], unknown>
) {
  return useQuery(
    [QUERY_KEYS.GET_TOPUP_CARD, userId, filter],
    () => indexCustomerTransactions(userId, filter),
    options
  );
}

export function useAdminReadTransaction(
  transactionId: string,
  options?: UseQueryOptions<ITopupPaymentTransaction, unknown>
) {
  return useQuery(
    [QUERY_KEYS.GET_TOPUP_CARD, transactionId],
    () => adminReadTransaction(transactionId),
    options
  );
}
